
















































































import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/views/browse-and-go/components/PageHeader.vue'
import { CARD_TYPE_LABEL, CARD_TYPES, formatDuration, normalizeSearch } from '@/services/browse-and-go/labels'
import { bngState, deleteCard, findOperation } from '@/services/browse-and-go/store'
import { CardType } from '@/services/browse-and-go/types'

@Component({
  name: 'BrowseAndGoCards',
  components: { PageHeader }
})
export default class extends Vue {
  private query = ''
  private operationId = ''
  private cardType: CardType | '' = ''
  private cardTypes = CARD_TYPES
  private formatDuration = formatDuration

  get operations() {
    return bngState.operations
  }

  get filtered() {
    const needle = normalizeSearch(this.query)
    return bngState.cards.filter(card => {
      if (this.operationId && card.operationModelId !== this.operationId) return false
      if (this.cardType && card.type !== this.cardType) return false
      if (!needle) return true
      const operation = findOperation(card.operationModelId)
      return normalizeSearch(card.name).includes(needle) || normalizeSearch(operation ? operation.name : '').includes(needle)
    })
  }

  private typeLabel(type: CardType) {
    return CARD_TYPE_LABEL[type]
  }

  private operationName(id: string) {
    const operation = findOperation(id)
    return operation ? operation.name : '—'
  }

  private editCard(id: string) {
    this.$router.push({ name: 'BrowseAndGoCardEdit', params: { id } })
  }

  private cloneCard(id: string) {
    this.$router.push({ name: 'BrowseAndGoCardCreate', query: { cloneFrom: id } })
  }

  private removeCard(id: string) {
    this.$confirm('Supprimer ce modèle de carte multi-choix ?', 'Supprimer', {
      type: 'warning',
      confirmButtonText: 'Supprimer',
      cancelButtonText: 'Annuler'
    }).then(() => {
      deleteCard(id)
      this.$message.success('Modèle de carte multi-choix supprimé')
    }).catch(() => undefined)
  }
}
